var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-button",
        {
          directives: [
            {
              name: "permission",
              rawName: "v-permission",
              value: "newsletters.create",
              expression: "'newsletters.create'"
            },
            {
              name: "ripple",
              rawName: "v-ripple.400",
              value: "rgba(255, 255, 255, 0.15)",
              expression: "'rgba(255, 255, 255, 0.15)'",
              modifiers: { "400": true }
            }
          ],
          attrs: { variant: "primary" },
          on: { click: _vm.addNew }
        },
        [
          _c("feather-icon", {
            staticClass: "mr-50",
            attrs: { icon: "PlusIcon" }
          }),
          _c("span", { staticClass: "align-middle" }, [
            _vm._v(_vm._s(_vm.$t("AddNew")))
          ])
        ],
        1
      ),
      _c("Grid", {
        ref: "grid",
        attrs: {
          service: _vm.service,
          route_name: "newsletters",
          order_column: "created_at",
          direction: "desc"
        },
        scopedSlots: _vm._u([
          {
            key: "filterZone",
            fn: function() {
              return [
                _c("div", { staticClass: "grid grid-cols-2 gap-2 pt-2" }, [
                  _c(
                    "div",
                    [
                      _c("select-suggestion", {
                        key: _vm.groupNewsKey,
                        staticClass: "required",
                        attrs: {
                          column: "name",
                          model: "GroupNews",
                          label: _vm.$t("group_news.group"),
                          appendClearOption: true,
                          placeholderText: "Digite o nome do grupo"
                        },
                        on: {
                          clearSelection: _vm.clearSubgroupNews,
                          "selected-model": _vm.clearSubgroupNews
                        },
                        model: {
                          value: _vm.selectedGroupNews,
                          callback: function($$v) {
                            _vm.selectedGroupNews = $$v
                          },
                          expression: "selectedGroupNews"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _c("select-suggestion", {
                        key: _vm.subgroupNewsKey,
                        staticClass: "required",
                        attrs: {
                          column: "name",
                          model: "SubgroupNews",
                          label: _vm.$t("subgroup_news.subgroup"),
                          appendClearOption: true,
                          placeholderText: "Digite o nome do subgrupo",
                          disabled: !_vm.enableSubgroupNews,
                          extraParamsFilters: {
                            group_news_id: _vm.selectedGroupNews
                              ? _vm.selectedGroupNews.id
                              : null
                          }
                        },
                        model: {
                          value: _vm.selectedSubgroupNews,
                          callback: function($$v) {
                            _vm.selectedSubgroupNews = $$v
                          },
                          expression: "selectedSubgroupNews"
                        }
                      })
                    ],
                    1
                  )
                ])
              ]
            },
            proxy: true
          },
          {
            key: "gridThead",
            fn: function() {
              return [
                _c("vs-th", { key: "id", attrs: { "sort-key": "id" } }, [
                  _vm._v("ID")
                ]),
                _c("vs-th", { key: "title", attrs: { "sort-key": "title" } }, [
                  _vm._v(_vm._s(_vm.$t("newsletter.title")))
                ]),
                _c(
                  "vs-th",
                  {
                    key: "group_news_name",
                    attrs: { "sort-key": "group_news_name" }
                  },
                  [_vm._v(_vm._s(_vm.$t("group_news.group")))]
                ),
                _c(
                  "vs-th",
                  {
                    key: "subgroup_news_name",
                    attrs: { "sort-key": "subgroup_news_name" }
                  },
                  [_vm._v(_vm._s(_vm.$t("subgroup_news.subgroup")))]
                ),
                _c(
                  "vs-th",
                  { key: "status", attrs: { "sort-key": "status" } },
                  [_vm._v(_vm._s(_vm.$t("newsletter.status")))]
                )
              ]
            },
            proxy: true
          },
          {
            key: "gridData",
            fn: function(props) {
              return _vm._l(props.data, function(tr, indextr) {
                return _c(
                  "vs-tr",
                  { key: indextr, attrs: { data: tr } },
                  [
                    _c("vs-td", { key: "id", attrs: { width: "5%" } }, [
                      _c("div", [_vm._v(" " + _vm._s(tr.id) + " ")])
                    ]),
                    _c("vs-td", { key: "title", attrs: { width: "20%" } }, [
                      _c("div", [_vm._v(" " + _vm._s(tr.title))])
                    ]),
                    _c(
                      "vs-td",
                      { key: "group_news_name", attrs: { width: "20%" } },
                      [_c("div", [_vm._v(" " + _vm._s(tr.group_news_name))])]
                    ),
                    _c(
                      "vs-td",
                      { key: "subgroup_news_name", attrs: { width: "20%" } },
                      [_c("div", [_vm._v(" " + _vm._s(tr.subgroup_news_name))])]
                    ),
                    _c("vs-td", { key: "status", attrs: { width: "15%" } }, [
                      _c("div", [_vm._v(" " + _vm._s(tr.status_fmt))])
                    ]),
                    _c("vs-td", { attrs: { width: "10%" } }, [
                      _c(
                        "div",
                        { staticClass: "flex flex-row gap-2" },
                        [
                          _c("feather-icon", {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: "newsletters.edit",
                                expression: "'newsletters.edit'"
                              },
                              {
                                name: "tooltip",
                                rawName: "v-tooltip.top",
                                value: {
                                  content: "Editar Informativo",
                                  delay: { show: 100, hide: 100 }
                                },
                                expression:
                                  "{content: 'Editar Informativo',delay: { show: 100, hide: 100 }}",
                                modifiers: { top: true }
                              }
                            ],
                            staticClass:
                              "h-5 w-5 mb-1 mr-1 stroke-current text-warning",
                            attrs: { icon: "EditIcon" },
                            on: {
                              click: function($event) {
                                return props.edit(props.data[indextr].id)
                              }
                            }
                          }),
                          _c("feather-icon", {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: "newsletters.clone",
                                expression: "'newsletters.clone'"
                              },
                              {
                                name: "tooltip",
                                rawName: "v-tooltip.top",
                                value: {
                                  content: "Clonar Informativo",
                                  delay: { show: 100, hide: 100 }
                                },
                                expression:
                                  "{content: 'Clonar Informativo',delay: { show: 100, hide: 100 }}",
                                modifiers: { top: true }
                              }
                            ],
                            staticClass:
                              "h-5 w-5 mb-1 mr-1 stroke-current text-primary",
                            attrs: { icon: "CopyIcon" },
                            on: {
                              click: function($event) {
                                return _vm.confirmClone(props.data[indextr].id)
                              }
                            }
                          }),
                          _c("feather-icon", {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: "newsletters.detail",
                                expression: "'newsletters.detail'"
                              },
                              {
                                name: "tooltip",
                                rawName: "v-tooltip.top",
                                value: {
                                  content: "Detalhar",
                                  delay: { show: 100, hide: 100 }
                                },
                                expression:
                                  "{content: 'Detalhar',delay: { show: 100, hide: 100 }}",
                                modifiers: { top: true }
                              }
                            ],
                            staticClass:
                              "h-5 w-5 mb-1 mr-1 stroke-current text-warning",
                            attrs: { icon: "EyeIcon" },
                            on: {
                              click: function($event) {
                                return _vm.detail(props.data[indextr].id)
                              }
                            }
                          }),
                          _c("feather-icon", {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: "newsletters.delete",
                                expression: "'newsletters.delete'"
                              },
                              {
                                name: "tooltip",
                                rawName: "v-tooltip.top",
                                value: {
                                  content: "Excluir",
                                  delay: { show: 100, hide: 100 }
                                },
                                expression:
                                  "{content: 'Excluir',delay: { show: 100, hide: 100 }}",
                                modifiers: { top: true }
                              }
                            ],
                            staticClass:
                              "h-5 w-5 mb-1 mr-1 stroke-current text-danger",
                            attrs: { icon: "Trash2Icon" },
                            on: {
                              click: function($event) {
                                return props.destroy(props.data[indextr])
                              }
                            }
                          }),
                          _c(
                            "vs-dropdown",
                            {
                              staticClass: "cursor-pointer",
                              attrs: {
                                "vs-custom-content": "",
                                "vs-trigger-click": ""
                              }
                            },
                            [
                              _c("feather-icon", {
                                staticClass: "h-5 w-5 mb-1 mr-1 stroke-current",
                                attrs: {
                                  type: "filled",
                                  icon: "MoreVerticalIcon"
                                }
                              }),
                              _c(
                                "vs-dropdown-menu",
                                [
                                  _c("vs-dropdown-item", [
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "clipboard",
                                            rawName: "v-clipboard:copy",
                                            value: _vm.buildLink(
                                              props.data[indextr].link
                                            ),
                                            expression:
                                              "buildLink(props.data[indextr].link)",
                                            arg: "copy"
                                          },
                                          {
                                            name: "clipboard",
                                            rawName: "v-clipboard:success",
                                            value: function() {
                                              _vm.notifySuccess(
                                                _vm.$vs,
                                                "Cópia realizada com sucesso."
                                              )
                                            },
                                            expression:
                                              "() => {notifySuccess($vs, 'Cópia realizada com sucesso.')}",
                                            arg: "success"
                                          },
                                          {
                                            name: "clipboard",
                                            rawName: "v-clipboard:error",
                                            value: function() {
                                              _vm.notifyError(
                                                _vm.$vs,
                                                "Não foi possível realizar a cópia."
                                              )
                                            },
                                            expression:
                                              "() => {notifyError($vs, 'Não foi possível realizar a cópia.')}",
                                            arg: "error"
                                          }
                                        ],
                                        staticClass: "flex",
                                        staticStyle: { width: "150px" }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "w-2/12" },
                                          [
                                            _c("feather-icon", {
                                              attrs: {
                                                icon: "LinkIcon",
                                                svgClasses:
                                                  "h-5 w-5 mb-1 stroke-current text-primary"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c("div", { staticClass: "w-10/12" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "flex bg-gray-200 float-left"
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t("action.copy_link")
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ])
                                      ]
                                    )
                                  ]),
                                  _vm.enableCloneByGroup(props.data[indextr])
                                    ? _c("vs-dropdown-item", [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "flex",
                                            staticStyle: { width: "150px" },
                                            on: {
                                              click: function($event) {
                                                return _vm.confirmCloneByGroup(
                                                  props.data[indextr]
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "w-2/12" },
                                              [
                                                _c("feather-icon", {
                                                  attrs: {
                                                    icon: "GridIcon",
                                                    svgClasses:
                                                      "h-5 w-5 mb-1 stroke-current text-primary"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "w-10/12" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "flex bg-gray-200 float-left"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "action.clone_by_group"
                                                          )
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm.enableCloneBySubgroup(props.data[indextr])
                                    ? _c("vs-dropdown-item", [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "flex",
                                            staticStyle: { width: "150px" },
                                            on: {
                                              click: function($event) {
                                                return _vm.confirmCloneBySubgroup(
                                                  props.data[indextr]
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "w-2/12" },
                                              [
                                                _c("feather-icon", {
                                                  attrs: {
                                                    icon: "ListIcon",
                                                    svgClasses:
                                                      "h-5 w-5 mb-1 stroke-current text-primary"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "w-10/12" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "flex bg-gray-200 float-left"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "action.clone_by_subgroup"
                                                          )
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ])
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ],
                  1
                )
              })
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }